const errorDetails = state => ({
    displayError: state.displayError,
    errorMessage: state.errorMessage,
});

export default errorDetails;
